import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import { CircularProgress } from '@mui/material';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();
    const location = useLocation();
    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                // Don't log errors for expected scenarios (like 204 on login page)
                if (err?.response?.status !== 204) {
                    console.error(err);
                }
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        // Skip refresh token verification on login page
        const isLoginPage = location.pathname === '/' || location.pathname === '/login';

        // Check if we already have auth in localStorage (including impersonation sessions)
        const storedAuth = JSON.parse(localStorage.getItem('auth') || '{}');
        const hasStoredToken = !!storedAuth?.accessToken;
        const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

        // Verify refresh token only if user wants to persist, doesn't have access token (in context or localStorage),
        // not on login page, and not in an impersonation session
        if (persist && !auth?.accessToken && !hasStoredToken && !isLoginPage && !isImpersonating) {
            verifyRefreshToken();
        } else {
            setIsLoading(false);
        }

        return () => isMounted = false;
    }, [])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                            backgroundColor: '#fff', zIndex: 9999
                        }}>
                            <span style={{ fontSize: '1.5rem', fontWeight: 600, color: 'var(--brand-red, #dc354d)', marginBottom: '24px' }}>UMS</span>
                            <CircularProgress size={36} sx={{ color: 'var(--brand-red, #dc354d)' }} />
                        </div>
                    )
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin
